// NFse sem notas (PO1-3301, épico PO1-3298): a NFse da transportadora chega
// sem vínculo com NF; o embarcador associa as notas (por romaneio ou por
// remetente × período) e o backend dispara o recálculo
// do frete (executionId da fila /recalculo/cte/executions/:id).
import api from "./api";

export async function listarNfseSemNotas(params = {}) {
  const { data } = await api.get("/nfse/sem-notas", { params });
  return (data && data.itens) || [];
}

// Paginado no servidor: { total, itens }. Filtra por idRomaneio OU por
// idEmbarcadorRemetente + de/ate.
export async function listarNotasCandidatas(idNfse, params = {}) {
  const { data } = await api.get(`/nfse/${idNfse}/notas-candidatas`, { params });
  return data || { total: 0, itens: [] };
}

// { vinculadas, executionId }
export async function associarNotas(idNfse, idsNotas) {
  const { data } = await api.post(`/nfse/${idNfse}/notas`, { idsNotas });
  return data;
}

// Mesma consulta da Auditoria de Faturas (modais.js) para acompanhar o recálculo.
export const FIM_EXECUCAO = ["completed", "completed_with_errors", "completed_with_business_errors"];

export async function consultarExecucaoRecalculo(executionId, params = {}) {
  const { data } = await api.get(`/recalculo/cte/executions/${executionId}`, { params });
  return data || {};
}
